<template>
</template>

<script>
export default {
    created(){
        this.$store.commit("setHeaderWhite", true)
    }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/gerenciador_header.vue